<template lang="pug">
  .container-listagem
    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
        )

    el-card.default-card(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Processos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar processos"
      )

      table-generica(
          :colunas="colunas",
          :botoesAcao="botoesAcao",
          :sortChanged='sortChanged',
          :dados='processosArrecadacao'
          )

    app-paginacao(
      :total="totalCadastros"
      :pagina="pagina",
      @changePage="changePage"
    )
</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import Utils from '@/utils/utils'
import statusProcesso from '@/constants/statusProcessoArrecadacao'
import statusOficio from '@/constants/statusOficioArrecadacao'
import TableGenerica from '@/components/TableGenerica'
import BaseFiltroArrecadacao from '@/screens/arrecadacao/mixins/BaseFiltroArrecadacao'
import FILTRO_EMPTY from '@/models/filtro'

export default {
  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    TableGenerica
  },

  mixins: [BaseFiltroArrecadacao],

  data () {
    return {
      colunas: [
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          sortable: 'custom',
          formatter: Utils.formatEmptyRow
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          sortable: 'custom',
          formatter: Utils.formatEmptyRow
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios',
          label: 'Município',
          formatter: this.formatMunicipio,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          sortable: 'custom',
          formatter: this.formatStatus
        }
      ],
      filtro: FILTRO_EMPTY('EM_ANALISE'),
      Utils
    }
  },

  created () {
    this.init()
    this.setMainCardVisibility(false)
  },

  methods: {
    ...mapActions({
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      tramitarCertidaoNegativa: 'oficioArrecadacao/tramitarCertidaoNegativa',
      iniciarAnalise: 'processoArrecadacao/iniciarAnalise'
    }),

    goToEmissaoOficio (processo) {
      if (processo.status === statusProcesso.AGUARDANDO_EMISSAO_OFICIO_CN) {
        this.tramitarCertidaoNegativa(processo.id)
      }
      this.$router.push({
        name: 'cpat/oficio',
        query: {
          idProcesso: processo.id
        }
      })
    },

    goToListagem (processo) {
      this.$router.push({
        name: 'cpat/oficios',
        query: {
          idProcesso: processo.id
        }
      })
    },

    getQuery (processo) {
      const query = {}

      if (processo.matricula) {
        query.idOficio = processo.matricula.id
      } else {
        query.idProcesso = processo.id
      }
      return query
    },

    goToMinuta (processo) {
      const query = this.getQuery(processo)
      this.$router.push({
        name: 'cpat/minuta',
        query
      })
    },

    async analisarProcesso (processo) {
      if (processo.status === statusProcesso.AGUARDANDO_ANALISE) {
        await this.iniciarAnalise({ processoId: processo.id })
      }
      this.$router.push({
        name: 'cpat/validacaoCadastro',
        query: {
          idProcesso: processo.id
        }
      })
    },

    enviarMatricula (processo) {
      this.$router.push({
        name: 'cpat/matricula',
        query: {
          idProcesso: processo.id
        }
      })
    },

    formatStatus (row, column, prop) {
      if (
        row.documentosAssinados.some(
          documento =>
            documento.status?.codigo === statusOficio.AGUARDANDO_RESPOSTA_SICARF
        )
      ) {
        return 'Cartório aguardando retorno'
      }
      return prop
    },

    botoesAcao (processo) {
      const acoes = []

      const codigo = processo.status

      if (codigo === statusProcesso.EM_ANALISE) {
        acoes.push({
          click: this.analisarProcesso.bind(this, processo),
          icon: 'list',
          title: 'Continuar Análise',
          active: true
        })
      }

      if (codigo === 'EM_REVISAO') {
        acoes.push({
          click: this.analisarProcesso.bind(this, processo),
          icon: 'list',
          title: 'Revisar Análise',
          active: true
        })
      }

      if (codigo === statusProcesso.EM_EMISSAO_OFICIO_CN) {
        acoes.push({
          click: this.goToEmissaoOficio.bind(this, processo),
          icon: 'check',
          title: 'Continuar emissão de Of. Certidão Negativa',
          active: true
        })
      }
      return acoes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/EmAnalise.vue